import React from 'react';

import baitaLogo from '@/assets/images/baita-bank-logo.svg';
import resetPasswordIllustration from '@/assets/images/reset-password-illustration.webp';
import { ResetPasswordForm } from '@features/authentication/components/ResetPasswordForm';

export interface ResetPasswordPageProps {
  /**
   * Title to display
   * @default 'Criação de senha'
   */
  title?: string;

  /**
   * Subtitle description
   * @default 'Escolha uma nova senha para esta conta de usuário.'
   */
  subtitle?: string;
}

export const ResetPasswordPage: React.FC<ResetPasswordPageProps> = ({
  title = 'Criação de senha',
  subtitle = 'Escolha uma nova senha para esta conta de usuário.',
}) => {
  return (
    <div className="flex flex-col lg:flex-row w-full h-screen">
      {/* Left Panel - Branding (Hidden on mobile, visible on lg+) */}
      <div className="hidden lg:flex lg:w-1/2 h-full relative overflow-hidden bg-neutral-50">
        {/* Illustration */}
        <div>
          <img
            src={resetPasswordIllustration}
            alt=""
            className="w-full h-full object-contain drop-shadow-2xl"
          />
        </div>
      </div>

      {/* Right Panel - Reset Password Form */}
      <div className="flex items-center justify-center p-6 lg:p-12 lg:w-1/2 h-full bg-neutral-50">
        <div className="w-full max-w-md">
          {/* Mobile Logo (visible on mobile only) */}
          <div className="lg:hidden text-center mb-8">
            <img src={baitaLogo} alt="Baita Bank" className="h-12 w-auto mx-auto mb-4" />
          </div>

          {/* Reset Password Card */}
          <div>
            <h1 className="text-4xl font-bold text-neutral-900 mb-2 text-center">{title}</h1>
            <p className="text-neutral-600 text-base mb-6 text-center">{subtitle}</p>

            <ResetPasswordForm />
          </div>
        </div>
      </div>
    </div>
  );
};
